import React from "react";
import PropTypes from "prop-types";
import LazyLoad from "react-lazyload";
import styles from "./ImageLink.module.css";

const ImageLink = ({ data }) => {
  const { items = [] } = data;

  return (
    <ul className={styles.list}>
      {items.length > 0 &&
        items.map((imagePanel, i) => {
          const {
            button: { link = {} } = {},
            header = {},
            image: { src = "", alt = "" } = {},
          } = imagePanel;

          if (!link.href) return null;

          return (
            <li key={`${header.text}-${i}`} className={styles.item}>
              <a
                className={styles.link}
                href={link.href}
                target={link.target || null}
              >
                <LazyLoad once>
                  <div className={styles.imgWrap}>
                    <img className={styles.image} src={src} alt={alt} />
                  </div>
                </LazyLoad>
                <p className={styles.text}>{header.text}</p>
                {imagePanel.button.text && (
                  <div>
                    <span
                      className={styles.button}
                      style={
                        imagePanel.button.isCaps
                          ? {
                              textTransform: "uppercase",
                            }
                          : {}
                      }
                    >
                      {imagePanel.button.text}
                    </span>
                  </div>
                )}
              </a>
            </li>
          );
        })}
    </ul>
  );
};

export default ImageLink;

ImageLink.propTypes = {
  data: PropTypes.object,
};
